import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { baseTheme } from '../../../theme';

interface IBaseCreateForm {
  children?: any;
  themeStyle?: 'dark' | 'light';
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
    dark: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
    },
    light: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
    },
  }),
);

export default function BaseCreateForm(props: IBaseCreateForm) {
  const { children, themeStyle = 'dark' } = props;
  const classes = useStyles(baseTheme);
  const determineTheme = themeStyle === 'light' ? classes.light : classes.dark;

  return (
    <Paper elevation={0} className={`${classes.root} ${determineTheme}`}>
      {children}
    </Paper>
  );
}
